/**************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var toggleForm = require('common/util/toggleForm');
const { assetAssessment, fiduciaryAssessment} = require('../services/CalculatorFunctions');

require('../styles/Calculator.css');

var tmplCalculatorView = require('../templates/CalculatorView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplCalculatorView,
  className: 'calculator-view',

  ui: {
    calculatorForm: '.calculator-form',
    bankType: '#bankType',
    totalAssetsSection: '#total-assets-section',
    totalAssets: '#totalAssets',
    assetUnit: '#asset-unit',
    fiduciaryAssetsSection: '#fiduciary-assets-section',
    fiduciaryAssets: '#fiduciaryAssets',
    resultSection: '#result-section',
    newResult: '#newResult',
    assetsData: '#assets-data',
    assetsAmount: '#assets-amount',
    fiduciaryData: '#fiduciary-data',
    fiduciaryAmount: '#fiduciary-amount',
    calculate: '#calculate',
    reset: '#reset'
  },

  events: {
    'change @ui.bankType': 'onChangeBankType',
    'change @ui.totalAssets': 'onChangeValidate',
    'change @ui.fiduciaryAssets': 'onChangeValidate',
    'click @ui.calculate': 'onCalculate',
    'click @ui.reset': 'onReset'
  },

  onBeforeShow: function () {
    document.title = 'Assessment Calculator';
    this.toggleSections();
  },

  onCalculate: function (e) {
    e.preventDefault();
    var bankType = this.ui.bankType.val();

    if (bankType !== '0') {
      var assets = new Number(this.ui.totalAssets.val());
      var fiduciary = new Number(this.ui.fiduciaryAssets.val());
      var newAAssessment = new Number(0);
      var newFAssessment = new Number(0);

      if (bankType === 'CU') {
        newAAssessment = assetAssessment(assets, bankType);
      } else if (bankType === 'TC') {
        newAAssessment = assetAssessment(assets * 1000, bankType);
        newFAssessment = fiduciaryAssessment(fiduciary * 1000);
      } else {
        // Bank
        newAAssessment = assetAssessment(assets * 1000, bankType);
      }

      toggleForm(this.ui.resultSection, true);

      var formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

      if (assets > 0) {
        var adjustAssets = bankType !== 'CU' ? assets * 1000 : assets;
        toggleForm(this.ui.assetsData, true);
        this.ui.assetsAmount.text(formatter.format(adjustAssets));
      } else {
        toggleForm(this.ui.assetsData, false);
      }
      if (bankType === 'TC') {
        toggleForm(this.ui.fiduciaryData, true);
        this.ui.fiduciaryAmount.text(formatter.format(fiduciary * 1000));
      } else {
        toggleForm(this.ui.fiduciaryData, false);
      }

      var newResultAssessment = newAAssessment * 2 + newFAssessment * 2;
      this.ui.newResult.text(formatter.format(newResultAssessment));
    }
  },

  onReset: function (e) {
    e.preventDefault();
    this.toggleSections();
  },

  onChangeBankType: function (e) {
    e.preventDefault();
    this.toggleSections();
    switch (this.ui.bankType.val()) {
      case 'CU':
        this.ui.assetUnit.text('.00');
        break;
      case 'TC':
        this.ui.assetUnit.text(',000.00');
        break;
      case 'BA':
        this.ui.assetUnit.text(',000.00');
        break;
      default:
        this.ui.calculate.prop('disabled', true);
        this.ui.reset.prop('disabled', true);
        break;
    }
  },

  onChangeValidate: function () {
    var ok = true;
    this.validate().fail(function () {
      ok = false;
    });

    if (ok) {
      if (this.ui.bankType.val() === 'TC') {
        if (this.ui.totalAssets.val() && this.ui.fiduciaryAssets.val()) {
          this.ui.calculate.prop('disabled', false);
          this.ui.reset.prop('disabled', false);
        }
      } else {
        if (this.ui.totalAssets.val()) {
          this.ui.calculate.prop('disabled', false);
          this.ui.reset.prop('disabled', false);
        }
      }
    } else {
      this.ui.calculate.prop('disabled', true);
      this.ui.reset.prop('disabled', true);
    }
  },

  validate: function () {
    return this.ui.calculatorForm.parsley().whenValidate();
  },

  toggleSections: function () {
    var bankType = this.ui.bankType.val();
    toggleForm(this.ui.totalAssetsSection, bankType !== '0');
    toggleForm(this.ui.fiduciaryAssetsSection, bankType === 'TC');
    toggleForm(this.ui.resultSection, false);
    this.ui.totalAssets.val('');
    this.ui.fiduciaryAssets.val('');
    this.ui.calculate.prop('disabled', true);
    this.ui.reset.prop('disabled', true);
  }
});
